import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getLookupsThunk } from "./lookups.thunk";
import { TGetLookupsResponse } from "../../services/apiV2.types";
import { ILookup } from "./lookups.types";

const lookupsSlice = createSlice({
  name: "lookups",
  initialState,
  reducers: {
    updateLookupsByAsin: (
      state,
      action: PayloadAction<{ asin: string } & Partial<ILookup>>,
    ) => {
      const { asin, ...props } = action.payload;
      state.lookups = state.lookups.map((lookup) => {
        return asin === lookup.asin
          ? {
              ...lookup,
              ...props,
            }
          : lookup;
      });
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLookupsThunk.pending, (state) => {
        state.loadingLookups = true;
      })
      .addCase(getLookupsThunk.fulfilled, (state, action) => {
        const { data, total, currPage, perPage } = action.payload;
        const lookups = data ?? [];
        state.total = total;
        state.loadingLookups = false;
        state.lookups = [...lookups];
      })
      .addCase(getLookupsThunk.rejected, (state) => {
        state.loadingLookups = false;
      });
  },
});

export const { updateLookupsByAsin } = lookupsSlice.actions;

export default lookupsSlice.reducer;
